import { withModifiers as _withModifiers, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { nextTick, computed } from "vue";
import SvgIcon from "./SvgIcon.vue";
export default {
  __name: 'Checkbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: "start"
    }
  },
  emits: ["update:value", "change"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var computedValue = computed({
      get: function get() {
        return props.value;
      },
      set: function set(val) {
        emit("update:value", val);
      }
    });
    function handleChangeValue() {
      var res = !computedValue.value;
      computedValue.value = res;
      nextTick(function () {
        emit("change", res);
      });
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["comp-checkbox", ['comp-checkbox--' + __props.align]])
      }, [_createVNode(SvgIcon, {
        class: "icon-checkbox",
        name: computedValue.value ? 'checkbox_checked' : 'checkbox',
        size: "20",
        onClick: _withModifiers(handleChangeValue, ["stop"])
      }, null, 8, ["name"]), _createElementVNode("div", {
        class: "checkbox-content",
        onClick: _withModifiers(handleChangeValue, ["stop"])
      }, [_renderSlot(_ctx.$slots, "default")])], 2);
    };
  }
};